import { Link } from "react-router-dom";
import ProductItemBase from "components/ProductItemBase";
import { ReplicaType } from "types";
import { checkIsNew } from "utils";
import { routes } from "config";

const ReplicaItem = (props: {
  replica: ReplicaType;
  version?: string;
  wide?: boolean;
  thin?: boolean;
  noLabel?: boolean;
}) => {
  const latestVersion = props.replica.versions[0];
  const replicaVersion = props.version
    ? props.replica.versions.find((v) => v.version === props.version)
    : latestVersion;

  const isLatestVersion = replicaVersion.version === latestVersion.version;

  const isNew = isLatestVersion && checkIsNew(latestVersion.datePublished);
  const isNewVersion = isNew && props.replica.versions.length > 1;

  //
  // RENDER
  //
  return (
    <Link
      to={`/${routes.replicas.slug}/${props.replica.id}${!isLatestVersion && props.version ? `/v${props.version}` : ""}`}
    >
      <ProductItemBase
        product={{
          ...props.replica,
          thumbnail: replicaVersion.thumbnail,
          thumbnailSize: replicaVersion.thumbnailSize,
        }}
        wide={props.wide}
        thin={props.thin}
        subtitle={props.replica.category.name}
        isNew={props.noLabel ? undefined : isNewVersion ? false : isNew}
        isNewVersion={
          props.noLabel
            ? undefined
            : isNew && replicaVersion && isNewVersion
              ? /* ? `New Version: v${latestVersion.version}` */
                `v${replicaVersion.version}`
              : undefined
        }
        thumbnailInfo={
          props.version
            ? {
                version: replicaVersion.version
                  ? `v${replicaVersion.version}`
                  : null,
                year: replicaVersion.dateCreated
                  ? replicaVersion.dateCreated?.getFullYear().toString()
                  : null,
                isLatestVersion: isLatestVersion,
              }
            : undefined
        }
      />
    </Link>
  );
};

export default ReplicaItem;
